import { DropCard } from '@/components/drops/DropCard'
import type { PublicListing } from '@/lib/types/listing'

export function DropGrid({
  listings,
  sample = false,
}: {
  listings: PublicListing[]
  sample?: boolean
}) {
  return (
    <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {listings.map((listing) => (
        <li key={listing.id}>
          <DropCard listing={listing} sample={sample} />
        </li>
      ))}
    </ul>
  )
}
